// extracted by mini-css-extract-plugin
export var providerSummary3 = "ProviderSummary3-module--providerSummary3--17FEa";
export var contentWrapper = "ProviderSummary3-module--contentWrapper--1A-xY";